export class PagoDuplicado{
    _id_pago_duplicado: Number;
    rut: String;
    nombre: String;
    telefono: String;
    email: String;
    numero_cliente: String;
    direccion: String;
    id_comuna: String;
    id_region: String;
    seleccion_pago_duplicado: String;
    numero_cliente_duplicado: String;
    direccion_duplicado: String;
    id_comuna_duplicado: String;
    medio_pago_duplicado: String;
    direccion_sucursal_duplicado: String;
    fecha_pago: Date;
    monto_cancelado: Number;
    recaudador_externo: String;
    nombre_banco: String;
    numero_cuenta: String;
    tipo_cuenta: String;
    archivo_rut_solicitante: String;
    archivo_rut_solicitante_reverso: String;
    archivo_cartola_voucher: String;
    archivo_monto_cancelado: String;
    archivo_poder_simple: String;
    acepto_condiciones: Boolean;
    acepto_newsletters: Boolean;
    acepto_privacidad: Boolean;
    acepto_suscripcion: Boolean;
    token: String;
    ip: String;
}